import { render, staticRenderFns } from "./OptionalPhoneSettings.vue?vue&type=template&id=4d602cc4&"
import script from "./OptionalPhoneSettings.vue?vue&type=script&lang=js&"
export * from "./OptionalPhoneSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports